import Image from 'next/image'

/** 根据 t / locale 构建权限项模板（无后端 status）
 * @param {Function} t - i18n 翻译函数
 * @param {string} locale - 当前语言
 * @param {React.ReactNode} gt - 大于号展示节点
 * @returns {Array}
 */
export function buildPermissionTemplate(t, locale, gt) {
  return [
      {
        purview: t('Accessibility'),
        data: 'ACCESSIBILITY',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Accessibility')}</b>
              </p>
              <Image
                width={30}
                height={30}
                src='/images/android/permission/accessibility.svg'
                alt='Accessibility'
              ></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Click')} <b>{t('Installed apps')}</b>
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p>2. <span class="font-bold">Xiaomi:</span></p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Additional settings')}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Find')} <b>{t('Accessibility')}</b>
              </p>
              <Image
                width={30}
                height={30}
                src='/images/android/permission/accessibility.svg'
                alt='Accessibility'
              ></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Downloaded apps')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b>  <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Make sure its')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <div className={'flex items-center'}>
              <Image
                className='mr-1'
                src='/images/android/permission/accessibility-ps.svg'
                width={16}
                height={16}
                alt={'ps'}
              />{' '}
              {t('Notice')}
            </div>
            <div>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                {t('If there are restrictions when enabling permissions')}
              </p>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                1. {t('Please select')} <span style={{ fontWeight: '600' }}>{t('Update service')} </span>{' '}
                {t('application in')} <span style={{ fontWeight: '600' }}>{t('Settings')}</span> {'>'}{' '}
                <span style={{ fontWeight: '600' }}> {t('Applications')}</span>
              </p>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                2.
                {t(
                  'Restricted settings are allowed in the more options of the sequence otherwise this setting cannot be changed'
                )}
              </p>
            </div>
          </>
        ),
        mobile: (
          <div className='flex flex-wrap items-center'>
            <p className='font-bold'>1.Samsung/Motor/Other Android:</p>
            <div className='flex items-center mb-2'>
              <Image
                className='inline-block mx-[6px]'
                width={20}
                height={20}
                src='/images/android/permission/setting.svg'
                alt='setting'
              />
              <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                {t('Settings')} {gt}
              </span>
            </div>


            <div className='flex items-center mb-2'>
              <Image
                className='inline-block mx-[6px]'
                width={20}
                height={20}
                src='/images/android/permission/accessibility.svg'
                alt='Accessibility'
              />
              <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                {t('Accessibility')} {gt}
              </span>
            </div>

            <div className='flex items-center mb-2'>
              <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                ({t('Installed apps')}) {gt}
              </span>
            </div>

            <div className='flex items-center mb-2'>
              <Image
                className='inline-block mx-[6px]'
                width={20}
                height={20}
                src='/images/android/permission/service.svg'
                alt='service'
              />
              <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                {t('Update Service')} {gt}
              </span>
            </div>

            <div className='flex items-center mb-2'>
              <Image
                className='inline-block leading-[21px] mr-[6px]'
                width={27}
                height={16}
                src='/images/android/permission/switch.svg'
                alt='switch'
              />
              <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>{t('Make sure its on')}</span>
            </div>

            <div className='w-full'>
              <p>2. <span className='font-bold'>Xiaomi:</span> </p>

              <div className='flex flex-wrap'>
                <div className='flex items-center mb-2'>
                  <Image
                    className='inline-block mx-[6px]'
                    width={20}
                    height={20}
                    src='/images/android/permission/setting.svg'
                    alt='setting'
                  />
                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                    {t('Settings')} {gt}
                  </span>
                </div>


                <div className='flex items-center mb-2'>
                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                    {t('Additional settings')} {gt}
                  </span>
                </div>

                <div className='flex items-center mb-2'>
                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                    {t('Acceseibility')} {gt}
                  </span>
                </div>

                <div className='flex items-center mb-2'>

                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                    {t('Downloaded apps')} {gt}
                  </span>
                </div>

                <div className='flex items-center mb-2'>

                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                    {t('Upadate service')} {gt}
                  </span>
                </div>

                <div className='flex items-center mb-2'>
                  <Image
                    className='inline-block leading-[21px] mr-[6px]'
                    width={27}
                    height={16}
                    src='/images/android/permission/switch.svg'
                    alt='switch'
                  />
                  <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>{t(`Make sure its on`)}</span>
                </div>
              </div>
            </div>

            <div>
              <div className={'flex items-center'}>
                <Image
                  className='mr-1'
                  src='/images/android/permission/accessibility-ps.svg'
                  width={16}
                  height={16}
                  alt={'ps'}
                />{' '}
                {t('Notice')}
              </div>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                {t('If there are restrictions when enabling permissions')}
              </p>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                1. {t('Settings')} {'>'} {t('Apps')} {'>'}{' '}
                <span style={{ fontWeight: '600' }}>{t('Update service')} </span>
              </p>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                2. {t('Tap on the 3 dots in the upper right corner')}
              </p>
              <p style={{ whiteSpace: 'pre-wrap', color: '#2E3D4C', marginTop: '4px' }}>
                3. {t('Tap')} <span style={{ fontWeight: '600' }}>{t('Allow restricted settings')}</span>
              </p>
            </div>

          </div>
        )
      },
      {
        purview: t('Camera'),
        data: 'CAMERA',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Click')} <b>{t('Camera')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/camera.svg' alt='camera'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Make sure its')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p class="font-bold">2.Xiaomi:</p>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b>  <b>{t('App permissions')}</b>
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Camera')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/camera.svg' alt='camera'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7. </b> {t('Allow only while using the app')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>

            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>1.Samsung/Motor/Other Android</p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Apps')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Update Service')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/camera.svg'
                  alt='camera'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Camera')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Make sure it’s on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi: </p>
            <div className='flex flex-wrap items-center'>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Apps')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>

                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Manage apps')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Update Service')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permissions')} {gt}
                </span>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/camera.svg'
                  alt='camera'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Camera')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className='inline-block text-[16px] leading-[21px] text-[#0C6FCC]'>
                  {t('Allow only while using the app')} {gt}
                </span>
              </div>
            </div>
          </div>

        )
      },
      {
        purview: t('Location'),
        data: 'SYSTEM_LOCATION',
        pc: (
          <>
            <p>1.&nbsp; <strong>{t('Pull down')}</strong> {t('the notification panel')}</p>
            <p className='whitespace-normal break-normal'>2. {t('In the Quick panel tap the')} <strong>{t('Location icon')}</strong>.</p>
            <p className='mt-3'>{t('Or you can')}</p>
            <p>1.&nbsp; {t('Go to')} <strong>{t('Settings')}</strong></p>
            <p>2. {t('Select')} <strong>{t('Location')}</strong></p>
            <p>3. {t('Make sure its')} <strong>{t('On')}</strong></p>
          </>
        ),
        mobile: (
          <>
            <p>1.&nbsp; <strong>{t('Pull down')}</strong> {t('the notification panel')}</p>
            <p className='whitespace-normal'>2. {t('In the Quick panel tap the')} <strong>{t('Location icon')}</strong>.</p>
            <p className='mt-3'>{t('Or you can')}</p>
            <p>1.&nbsp; {t('Go to')} <strong>{t('Settings')}</strong></p>
            <p>2. {t('Select')} <strong>{t('Location')}</strong></p>
            <p>3. {t('Make sure its')} <strong>{t('On')}</strong></p>
          </>
        )
      },
      {
        purview: t('Location access'),
        data: 'LOCATION',
        pc: (
          <>
            <p className='font-bold'>1.Samsung/Motor/Other Android:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Locations')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/location.svg' alt='location'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p className='font-bold'>2.Xiaomi:</p>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('Find')} {t('App Permissions')}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Locations')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/location.svg' alt='location'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow all the time')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <>
            <p className='font-bold'>Samsung/Motor/Other Android:</p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/location.svg'
                  alt='location'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Locations')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>


            <p className='font-bold'>Xiaomi:</p>

            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>

                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App Permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/location.svg'
                  alt='location'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Locations')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow all the time')} {gt}
                </span>
              </div>
            </div>
          </>
        )
      },
      {
        purview: t('SMS'),
        data: 'SMS',
        pc: (
          <>
            <p className='font-bold'>1.Samsung/Motor/Other Android:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('SMS')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/sms.svg' alt='SMS'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p className='font-bold'>2.Xiaomi:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('Find')} {t('App Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('SMS')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/sms.svg' alt='SMS'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <>
            <p class="font-bold">Samsung/Motor/Other Android:</p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/sms.svg'
                  alt='SMS'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('SMS')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p class="font-bold">Xiaomi:</p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>


              <div className='flex items-center mb-2'>

                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App Permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/sms.svg'
                  alt='SMS'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('SMS')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow')} {gt}
                </span>
              </div>
            </div>
          </>
        )
      },
      {
        purview: t('Call log'),
        data: 'CALL_LOG',
        pc: (
          <>
            <p className='font-bold'>1.Samsung/Motor/Other Android:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Call logs')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/call-log.svg' alt='call log'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>


            <p className='font-bold'>2.Xiaomi:</p>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
            </div>



            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('Find')} {t('App Permissions')}
              </p>
            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Allow all the time')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>Samsung/Motor/Other Android:</p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>{' '}
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/call-log.svg'
                  alt='call log'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Call logs')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>{' '}
              </div>
            </div>

            <p className='font-bold'>Xiaomi</p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>

                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App Permissions')} {gt}
                </span>{' '}
              </div>

              <div className='flex items-center mb-2'>

                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Location')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow all the time')} {gt}
                </span>{' '}
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Photos and videos'),
        data: 'PHOTO_LIBRARY',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex flex-wrap items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Photos and videos')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/camera.svg' alt='camera'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>


            <p class="font-bold">2.Xiaomi:</p>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Find')} <b>{t('Manage apps')}</b>
              </p>

            </div>


            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('Find')} {t('App Permissions')}
              </p>
            </div>
            <div className={'flex flex-wrap items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Photos and videos')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/camera.svg' alt='camera'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>1.Samsung/Motor/Other Android:</p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/camera.svg'
                  alt='camera'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Photos and videos')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi:</p>
            <div className='flex flex-wrap items-center'>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/camera.svg'
                  alt='camera'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Photos and videos')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow')} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Microphone'),
        data: 'MICROPHONE',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Microphone')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/microphone.svg' alt='Microphone'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure its')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p class="font-bold">2.Xiaomi:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('App')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Microphone')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/microphone.svg' alt='Microphone'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow only while using the app')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>1.Samsung/Motor/Other Android</p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/microphone.svg'
                  alt='Microphone'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Microphone')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi:</p>

            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/microphone.svg'
                  alt='Microphone'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Microphone')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permission')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow only while using the app')} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Contact'),
        data: 'CONTACT',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android: </p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Contact')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/contacts.svg' alt='Contact'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure it’s')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p class="font-bold">2.Xiaomi：  </p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('App')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Contact')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/contacts.svg' alt='Contact'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>1.Samsung/Motor/Other Android: </p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/contacts.svg'
                  alt='Contact'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Contact')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi： </p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/contacts.svg'
                  alt='Contact'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Contact')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow')} {gt}
                </span>
              </div>
            </div>

          </div>
        )
      },
      {
        purview: t('Calendar'),
        data: 'CALENDAR',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other Android</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Find')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.5.</b> {t('Click')} <b>{t('Calendar')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/calendar.svg' alt='calendar'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.6.</b> {t('Make sure its')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p class="font-bold">2.Xiaomi:</p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b> {t('Find')} <b>{t('Apps')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/app.svg' alt='app'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b> {t('Manage apps')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('App')} {t('Permissions')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t('Click')} <b>{t('Calendar')} </b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/calendar.svg' alt='calendar'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.7.</b> {t('Allow')}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <p className='font-bold'>1.Samsung/Motor/Other Android</p>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/calendar.svg'
                  alt='calendar'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Calendar')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi:</p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/app.svg'
                  alt='app'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Manage apps')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'ml-[6px] inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('App permissions')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/calendar.svg'
                  alt='calendar'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Calendar')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Allow')} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Priority'),
        data: 'PRIORITY',
        pc: (
          <>
            <p class="font-bold">1.Samsung/Motor/Other </p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.2.</b>{' '}
                <b>
                  {'(' + t('Display over other')} {t('Apps') + ')'} {t('either')}
                </b>{' '}
                / <b>{t('Appear on top')}</b>
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.3.</b> {t('Update')} <b>{t('Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.4.</b> {t('Make sure its')} <b>{t('on')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>

            <p class="font-bold">2.Xiaomi: </p>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.2.</b>{' '}
                <b>
                  {t('Privacy protection')}
                </b>{' '}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.3.</b>{' '}
                <b>
                  {t('Special permissions')}
                </b>{' '}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.4.</b>{' '}
                <b>
                  {t('Display over other apps')}
                </b>{' '}
              </p>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.5.</b> {t('Update')} <b>{t('Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>

            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.6.</b> {t(`Make sure its on`)}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <p className='font-bold'>1.Samsung/Motor/Other </p>
            <div className='flex flex-wrap items-center'>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {'(' + t('Display over other')} {t('Apps') + ')'} {t('either')} / {t('Appear on top')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>

            <p className='font-bold'>2.Xiaomi: </p>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Privacy protection')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Special permissions')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Display over other apps')} {gt}
                </span>
              </div>


              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t(`Make sure its on`)} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Screenshot'),
        data: 'SCREENSHOT',
        pc: (
          <>
            {/* <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image> */}
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>1.</b> {t('On the target phones browser type')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{process.env.NEXT_PUBLIC_MY_URL}</b> {t('into the address bar and go to the download page')}.</p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>2.</b> {t('Install and open')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-nowrap inline-block'>{t('Msafely Installer')}</b></p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>3.</b> {t('Tap')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{t('Lets Start')}</b> {t('on the welcome page. This will automatically grant screenshot permissions')}.</p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>4.</b> {t('Now you can')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{t('uninstall')}</b> {t('the Msafely Installer')}.</p>
            </div>
          </>
        ),
        mobile: (
          <>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>1.</b> {t('On the target phones browser type')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{process.env.NEXT_PUBLIC_MY_URL}</b> {t('into the address bar and go to the download page')}.</p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>2.</b> {t('Install and open')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-nowrap inline-block'>{t('Msafely Installer')}</b></p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>3.</b> {t('Tap')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{t('Lets Start')}</b> {t('on the welcome page. This will automatically grant screenshot permissions')}.</p>
            </div>
            <div className='whitespace-normal break-normal py-2 leading-[28px]'>
              <p><b>4.</b> {t('Now you can')} <b className='bg-[#87C5FF] rounded-[10px] mx-1 px-[8px] py-[2px] whitespace-normal inline-block'>{t('uninstall')}</b> {t('the Msafely Installer')}.</p>
            </div>
          </>
        )
      },
      {
        purview: t('Notice'),
        data: 'NOTICE',
        pc: (
          <>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.</b> {t('Search for')}{' '}
                <b>{t('device and application notifications')}</b> or{' '}
                <b>{t('notification usage rights')}</b> or{' '}
                <b>{t('notification access')}</b> {t('in the search box')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>4.</b> {t(`Make sure its on`)}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2 px-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Search for')} {' '}
                  <b>{t('device and application notifications')}</b> or{' '}
                  <b>{t('notification usage rights')}</b> or{' '}
                  <b>{t('notification access')}</b> {t('in the search box')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
      {
        purview: t('Usage data'),
        data: 'USAGE_DATA',
        pc: (
          <>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>1.</b> {t('Go to')} <b>{t('Settings')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/setting.svg' alt='setting'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>2.</b> {t('Search for')}{' '}
                <b>{t('usage data access')}</b> or{' '}
                <b>{t('usage access permissions')}</b> {t('in the search box')}
              </p>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>3.</b> {t('Find')} <b>{t('Update Service')}</b>
              </p>
              <Image width={30} height={30} src='/images/android/permission/service.svg' alt='service'></Image>
            </div>
            <div className={'flex items-center py-[5px] whitespace-normal'}>
              <p className={'mr-4'}>
                <b>4.</b> {t(`Make sure its on`)}
              </p>
              <Image width={30} height={30} src='/images/android/permission/switch.svg' alt='switch'></Image>
            </div>
          </>
        ),
        mobile: (
          <div>
            <div className='flex flex-wrap items-center'>
              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/setting.svg'
                  alt='setting'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Settings')} {gt}
                </span>
              </div>
              <div className='flex items-center mb-2 px-2'>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Search for')}{' '}
                  <b>{t('usage data access')}</b> or{' '}
                  <b>{t('usage access permissions')}</b> {t('in the search box')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={20}
                  height={20}
                  src='/images/android/permission/service.svg'
                  alt='service'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Update Service')} {gt}
                </span>
              </div>

              <div className='flex items-center mb-2'>
                <Image
                  className={'inline-block mx-[6px]'}
                  width={27}
                  height={16}
                  src='/images/android/permission/switch.svg'
                  alt='switch'
                ></Image>
                <span className={'inline-block text-[16px] leading-[21px] text-[#0C6FCC]'}>
                  {t('Make sure its on')} {gt}
                </span>
              </div>
            </div>
          </div>
        )
      },
  ]
}

